<script setup>
import { RouterView } from 'vue-router'
import { useThemeStore } from '@/stores/theme'
import { useClockStore } from '@/stores/clock'
import { watchEffect, ref, onMounted, onUnmounted } from 'vue'

const themeStore = useThemeStore()
const clockStore = useClockStore()

watchEffect(() => {
  if (themeStore.theme === 'dark') {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
})
const interval = ref(null)
onMounted(async () => {
  await clockStore.fetchTime()
  interval.value = setInterval(() => {
    clockStore.serverTime += 125
  }, 125)

  document.addEventListener('visibilitychange', async () => {
    location.reload()
  })
})

onUnmounted(() => {
  if (interval.value) {
    clearInterval(interval.value)
  }
})
</script>

<template>
  <RouterView />
</template>
